import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import { Avatar as MUIAvatar } from '@material-ui/core';
import AccountIcon from '@material-ui/icons/AccountCircle';

const StyledAvatar = styled(MUIAvatar)`
  && {
    height: 32px !important;
    width: 32px !important;
    background-color: white;
    background-color: ${({ theme }) => theme.colors.neutrals[8]};
    font-size: 12px;
    font-family: ${({ theme }) => theme.fonts.body};
    svg {
      font-size: 14px;
    }
  }
`;

const Avatar = ({ className, firstName, lastName, url, email }) => {
  return (
    <StyledAvatar
      data-testid="avatar"
      className={className}
      alt={firstName || 'AccountIcon'}
      src={email ? url : ''}
    >
      {isEmpty(firstName) || isEmpty(lastName) ? (
        <AccountIcon />
      ) : (
        `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`
      )}
    </StyledAvatar>
  );
};

export default Avatar;
